<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      id="input-identification-number"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "../../../../mixins/profileInputMixin";

export default {
  name: "IdentificationNumber",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('personal_identification_number', 'identityVerification', 'identityVerificationFieldOnInput')],

  data() {
    return {
      defaultLabel: this.$t("Identification Number")
    }
  },
}
</script>

<style scoped>

</style>
